import SEO from "components/Seo";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import styled from "styled-components";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import useHeaderTitleSetter from "../customHooks/useHeaderTitleSetter";

const SponsorMeLayout = ({ currentSection, ...props }) => {
  const { t } = useTranslation("common");
  const title = t("sponsor-me");
  const description = t("sponsor-me_desc");

  useHeaderTitleSetter({ section: "donate", title });
  const matches = useMobile("lg");
  return (
    <>
      <SEO title={title} description={description} />
      <CustomJumbotron
        m=" "
        p="py-4"
        breadCrumbM="my-0"
        className="border-bottom"
        title={title}
        desc={description}
        customBreadCrumbs={
          <CustomBreadCrumbs
            transformedLabel={(label) => {
              return title
            }}
          />
        }
      />
      {/* </div> */}
      <div className="container">
        <div className={matches ? "" : "mt-24rem"}>{props.children}</div>
      </div>
    </>
  );
};

export default SponsorMeLayout;

export const StyledDonateBar = styled.div<{ scroll: boolean }>`
  .navbar-floating {
    z-index: ${({ scroll }) => (scroll ? "1005" : "5")};
    top: ${({ scroll }) => (scroll ? "75px" : "0")};
  }
  @media (max-width: 991.98px) {
    .navbar-floating {
      top: ${({ scroll }) => (scroll ? "55px" : "0")};
    }
  }
  .rts___tab {
    padding: 5px 30px;
  }
  /* position: sticky; */
  /* z-index: 6 !important; */

  background-color: var(--white);
  @media (max-width: 991.98px) {
    /* position: relative !important;
    z-index: unset;
    top: unset; */
    .navbar-floating {
      position: relative !important;
      z-index: unset;
      top: unset;
    }
    .navbar-sticky.navbar-stuck {
      position: relative !important;
      z-index: unset;
      top: unset;
    }
    .sticky-lg-nav {
      position: fixed;
      z-index: ${({ scroll }) => (scroll ? "1005" : "5")};
    }
  }
`;
